// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-tab .filter-radio-group-title[data-v-3205c950] {\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n.filter-tab .filter-tree[data-v-3205c950] {\n  height: 100%;\n  overflow: auto;\n}\n.theme--light.filter-tab[data-v-3205c950] {\n  background-color: #f6f6f6;\n}\n.theme--dark.filter-tab[data-v-3205c950] {\n  background-color: #273039;\n}", ""]);
// Exports
module.exports = exports;
